module.exports = __webpack_public_path__ + "img/client-8.ffc2fd7c.png";